export interface TrackDef {
  id: string;
  name: string;
  file: string;
  attribution: string;
  license: string;
}

export const TRACKS: TrackDef[] = [
  {
    id: 'william_tell',
    name: '8비트 클래식',
    file: '/assets/audio/bgm/william_tell_8bit.mp3',
    attribution: 'Classical 8 Bit (classical8bit.tumblr.com)',
    license: 'CC BY',
  },
  {
    id: 'hero_quest',
    name: '영웅의 여정',
    file: '/assets/audio/bgm/hero_quest.mp3',
    attribution: 'PTY - Hero Quest Piano (Phaser3 Examples)',
    license: 'CC',
  },
  {
    id: 'rock_4bit',
    name: '4비트 록',
    file: '/assets/audio/bgm/rock_4bit.mp3',
    attribution: 'Bodenständig 2000 in Rock (4bit)',
    license: 'CC',
  },
  {
    id: 'heroquest_pop',
    name: '팝 어드벤처',
    file: '/assets/audio/bgm/heroquest_pop.mp3',
    attribution: 'Totta - HeroQuest Pophousedub Remix',
    license: 'CC',
  },
  {
    id: 'enthusiast',
    name: '열정',
    file: '/assets/audio/bgm/enthusiast.mp3',
    attribution: 'Tours - Enthusiast (freemusicarchive.org)',
    license: 'CC BY 4.0',
  },
  {
    id: 'night_owl',
    name: '야간 비행',
    file: '/assets/audio/bgm/night_owl.mp3',
    attribution: 'Broke For Free - Night Owl (freemusicarchive.org)',
    license: 'CC BY 4.0',
  },
  {
    id: 'jungle',
    name: '정글 비트',
    file: '/assets/audio/bgm/jungle.mp3',
    attribution: 'Jungle Loop (Phaser3 Examples)',
    license: 'CC',
  },
  {
    id: 'shmup',
    name: '슈팅게임',
    file: '/assets/audio/bgm/shmup.mp3',
    attribution: 'CatAstroPhi - Shmup Normal',
    license: 'CC',
  },
];

export function getTrackById(id: string): TrackDef | undefined {
  return TRACKS.find((t) => t.id === id);
}
